"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessage = void 0;

var e = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var s = function s(_s) {
  var t = _s.as,
      a = _s.errors,
      m = _s.name,
      o = _s.message,
      i = _s.render,
      l = function (e, r) {
    if (null == e) return {};
    var n,
        s,
        t = {},
        a = Object.keys(e);

    for (s = 0; s < a.length; s++) {
      r.indexOf(n = a[s]) >= 0 || (t[n] = e[n]);
    }

    return t;
  }(_s, ["as", "errors", "name", "message", "render"]),
      f = (0, _reactHookForm.useFormContext)(),
      c = (0, _reactHookForm.get)(a || f.formState.errors, m);

  if (!c) return null;
  var g = c.message,
      u = c.types,
      d = Object.assign({}, l, {
    children: g || o
  });
  return /*#__PURE__*/e.isValidElement(t) ? /*#__PURE__*/e.cloneElement(t, d) : i ? i({
    message: g || o,
    messages: u
  }) : /*#__PURE__*/e.createElement(t || e.Fragment, d);
};

exports.ErrorMessage = s;